"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _ = require(".");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const ValidSettings = Object.freeze(_object_spread({
    ALPHA_LEVEL: "irAlphaLevel",
    PIP_MODE: "pipMode",
    // irPaletteSetup
    PALETTE_SCHEME: "paletteScheme",
    PALETTE_SCALE_MODE: "paletteScaleMode",
    PALETTE_RANGE_MIN: "paletteRangeMinTempC",
    PALETTE_RANGE_MAX: "paletteRangeMaxTempC",
    BACKGROUND_TEMP: "backgroundTemp",
    IR_ORIENTATION: "irOrientation",
    // THERMAL_IMAGE_INFO_DATA
    CAPTURED_EMISSIVITY: "capturedEmissivity",
    CAPTURED_BACKGROUND_TEMP: "capturedBackgroundTempC",
    CAPTURED_TRANSMISSION: "capturedTransmissionFactor",
    // markers (custom)
    MARKERS_STANDARD: "standardMarkers",
    TEXTNOTES: _.ImageInfoKeys.TEXTNOTES,
    OCR_TEXT: "ocrText"
}, _.IRViewerKeys));
const _default = ValidSettings;
